// The dock's floating ↔ mini player state (owner 2026-10-21; Android DockState.minimized / miniPreferred). Making the
// dock small never pauses YouTube any more: it becomes the bottom mini player, which keeps a visible 200×200 player.
import { create, type StoreApi, type UseBoundStore } from "zustand";
import { WALL_KEY } from "../lib/dockMini";
import { useAuthStore } from "./authStore";
import { useWallPlaybackStore } from "./wallPlaybackStore";

export interface DockMiniState {
  /** The dock is the bottom mini player (else the floating dock). */
  minimised: boolean;
  /** The player the user minimised from (dock key): the mini player shows it first while it is in the dock. */
  preferred: string | null;
  minimise(preferred?: string | null): void;
  /** Back to the floating dock. */
  open(): void;
  reset(): void;
}

export const useDockMiniStore: UseBoundStore<StoreApi<DockMiniState>> = create<DockMiniState>()((set) => ({
  minimised: false,
  preferred: null,
  minimise: (preferred = null) => set({ minimised: true, preferred }),
  open: () => set({ minimised: false, preferred: null }),
  reset: () => set({ minimised: false, preferred: null }),
}));

// A wall item the user just played shows in the mini player (not hidden behind another player).
useWallPlaybackStore.subscribe((s, prev) => {
  const cur = s.current;
  if (!cur || !useDockMiniStore.getState().minimised) return;
  // Next / prev / pause inside the same post change nothing about which player shows.
  if (prev.current?.post.id === cur.post.id) return;
  useDockMiniStore.setState({ preferred: WALL_KEY });
});

// Logout or another account: the next user gets the floating dock.
useAuthStore.subscribe((s, prev) => {
  if ((prev.username && !s.username) || (prev.userId != null && s.userId !== prev.userId)) useDockMiniStore.getState().reset();
});
